import { mockupSrc } from "../../lib/mockup";

export const ProductPicker = ({ products, value, onPick }) => (
  <div className="grid grid-cols-3 gap-2" data-testid="design-product-picker">
    {products.map((p) => (
      <button key={p.id} onClick={() => onPick(p)} className={`rounded-xl border p-2 text-center transition-colors ${value?.id === p.id ? "border-[#E5202A] bg-[#E5202A]/10" : "border-white/10 hover:border-white/30"}`} data-testid={`design-product-${p.id}`}>
        <img src={mockupSrc(p, p.colors[0], "front")} alt="" className="mx-auto aspect-square w-full object-contain" />
        <span className="mt-1 block font-display text-sm font-bold uppercase leading-tight">{p.name}</span>
      </button>
    ))}
  </div>
);

export const ColorSwatches = ({ colors, value, onPick }) => (
  <div className="flex flex-wrap gap-2">
    {colors.map((c, i) => (
      <button key={`${c.name}-${i}`} onClick={() => onPick(i)} title={c.name}
        className={`h-9 w-9 overflow-hidden rounded-full border-2 transition-transform hover:scale-110 ${i === value ? "border-[#E5202A] ring-2 ring-[#E5202A]/40" : "border-white/30"}`}
        style={{ background: c.hex }} data-testid={`design-color-${i}`} />
    ))}
  </div>
);

export const DEFAULT_FONTS = ["Bebas Neue", "Anton", "Graduate", "Black Ops One", "Permanent Marker", "Pacifico", "Lobster", "Oswald"];

export const fontsHref = (fonts) => `https://fonts.googleapis.com/css2?${fonts.map((f) => `family=${encodeURIComponent(f).replace(/%20/g, "+")}`).join("&")}&display=swap`;
